import styled from "styled-components";

export const PageWrapper = styled.div<{
    $stretch?: boolean;
    $isDoubleBar: boolean;
    $padding?: string;
    $topBarHeight: string;
}>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: ${({ $padding }) => $padding ?? "32px"};
    background-color: ${({ theme }) => theme.v2.colors["background-primary-25"]};
    margin-bottom: ${({ $stretch, $topBarHeight }) => ($stretch ? $topBarHeight : 0)};

    ${({ $stretch, $isDoubleBar }) =>
        $stretch &&
        `
        min-height: calc(100vh - 64px - ${$isDoubleBar ? "64px" : "0px"});
  `}
`;

export const Content = styled.div<{ $stretch?: boolean }>`
    margin: 0;
    padding: 0;
    flex: ${({ $stretch }) => ($stretch ? `0` : `1`)};
    display: flex;
    align-items: center;
    align-self: stretch;

    & > * {
        flex: 1;
    }
`;
